/* eslint-disable react/jsx-props-no-spreading */
import {TabContext} from '@mui/lab';
import MuiTabPanel from '@mui/lab/TabPanel';
import {Box} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';
import {func, node, oneOfType} from 'prop-types';

import useOverflowedTabs from '../../hooks/components/tabs/useOverflowedTabs/useOverflowedTabs';
import useProjects from '../../hooks/providers/useProjects';
import useWorkspaces from '../../hooks/providers/useWorkspaces';
import DeleteReportModal from '../workspaces/DeleteWorkspaceOrReportModal';
import CreateOrImportReportModal from '../workspaces/import-or-create-report/CreateOrImportReportModal/CreateOrImportReportModal';
import ReportTabsMenu from '../workspaces/ReportTabsMenu';
import CreateReportButton from './CreateReportButton/CreateReportButton';
import CustomReportTabs from './CustomReportTabs';
import OverflowedTabs from './OverflowedTabs/OverflowedTabs';
import OverflowedTabsMenu from './OverflowedTabsMenu';

const Container = muiStyled(Box)(() => ({
  width: '100%',
  typography: 'body1',
  display: 'flex',
  flexDirection: 'column',
  flex: 1
}));

const TabsContainer = muiStyled(Box)(() => ({
  width: '100%',
  margin: '0 auto',
  background: '#F5F5F5',
  display: 'flex',

  position: 'sticky',
  zIndex: 99,
  top: 140
}));

const TabPanel = muiStyled(MuiTabPanel)(({theme}) => ({
  padding: 0
}));

const ReportTabs = ({children}) => {
  const {selectedReportTab, setSelectedReportTab} = useProjects();
  const {selectedWorkspace} = useWorkspaces();

  const getSortedReports = () => {
    return selectedWorkspace?.reports?.sort((a, b) => a.report_name?.toLowerCase().localeCompare(b.report_name?.toLowerCase())) || [];
  };

  const alphabeticallySortedReports = getSortedReports();

  const {containerRef, visibleItems, overflowedItems: overflowedReports} = useOverflowedTabs(alphabeticallySortedReports);

  return (
    <Container>
      <TabContext value={selectedReportTab}>
        <TabsContainer>
          <OverflowedTabs
            visibleItems={visibleItems}
            overflowedItems={overflowedReports}
            rightToolbar={<CreateReportButton />}
            renderMenu={({anchorEl, isOpen, onClose, overflowedItems}) => (
              <OverflowedTabsMenu
                tabs={overflowedItems.map(r => ({
                  value: r.report_id,
                  label: r.report_name
                }))}
                entityName="rapport"
                onItemSelect={setSelectedReportTab}
                anchorEl={anchorEl}
                isOpen={isOpen}
                onClose={onClose}
              />
            )}
          >
            <Box ref={containerRef} width="100%">
              <CustomReportTabs />
            </Box>
          </OverflowedTabs>
        </TabsContainer>

        {alphabeticallySortedReports?.map(r => (
          <TabPanel key={r.report_id} value={r.report_id}>
            {children}
          </TabPanel>
        ))}

        <ReportTabsMenu />
        <DeleteReportModal isReportDeletion />
      </TabContext>

      <CreateOrImportReportModal />
    </Container>
  );
};

ReportTabs.propTypes = {
  children: oneOfType([node, func])
};

export default ReportTabs;
